"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Drawer } from "@filadd/phi-plus-core";
import { drawerRecipe } from "./recipes";
import { TopBar } from "./TopBar";
export const MobileSideNavDrawer = ({ children, topBar, goBack, }) => {
    const styles = drawerRecipe();
    const [isOpen, setIsOpen] = useState(false);
    return (_jsxs(Drawer.Root, { onOpenChange: (change) => setIsOpen(change.open), open: isOpen, children: [_jsx(TopBar, { goBack: goBack, onOpenSidebar: () => setIsOpen(true), className: styles.topBar, children: topBar }), _jsx(Drawer.Backdrop, { className: styles.backdrop }), _jsx(Drawer.Positioner, { className: styles.positioner, children: _jsx(Drawer.Content, { className: styles.content, children: children }) })] }));
};
//# sourceMappingURL=MobileSideNavDrawer.js.map